module.exports = __webpack_public_path__ + "img/pagarme.7f0b8f56.svg";